import { ref } from 'vue'

export default () => ({
  passkeys: ref([])
})
